import React, { useState, useEffect, useRef, CSSProperties } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { Load } from '../../components/Load';
import { Header } from '../../components/Header';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { Button, Col, Row, Form, Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import './style.css';
import AlertMessage from '../../components/Alert';
import { useParams } from 'react-router-dom';
import { Trash, Plus, ArrowLeft } from 'react-bootstrap-icons';
import { Autocomplete, TextField, Box, Modal, Typography, Button as MUIButton } from '@mui/material';
import { CardContent } from '../../components/CardContent';
import { Title } from '../../components/Title';
import { DateTime } from 'luxon';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Refresh } from '@mui/icons-material';
import Logo from '../../img/doc-atento.png';
import QRCode from 'qrcode.react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import InputMask from 'react-input-mask';

export function EditarReaproveitamentoEmpresaAdm() {

    const { indexAso } = useParams()

    const [isLoading, setIsLoading] = useState(true);
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [showModal, setShowModal] = useState(false);
    const [trabalhador, setTrabalhador]: any = useState();
    const [funcoes, setFuncoes]: any = useState([])
    const [funcaoAtribuida, setFuncaoAtribuida]: any = useState();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [empresa, setEmpresa]: any = useState();
    const [novoExame, setNovoExame] = useState({ nome: '', data_realizacao: '', valor_total: '' });
    const [novoRisco, setNovoRisco] = useState({ nome: '' })
    const [mostrarNovoExame, setMostrarNovoExame] = useState(false);
    const [mostrarNovoRisco, setMostrarNovoRisco] = useState(false);
    const [exameSelecionado, setExameSelecionado]: any = useState();
    const [riscoSelecionado, setRiscoSelecionado]: any = useState()
    const [exames, setExames]: any = useState([]);
    const [riscos, setRiscos]: any = useState([]);
    const [liberado, setLiberado] = useState(false);
    const [assinadoTrabalhador, setAssinadoTrabalhador] = useState(false)
    const [reaproveitamento, setReaproveitamento]: any = useState();
    const [cnae, setCnae]: any = useState()
    const [idArquivo, setIdArquivo]: any = useState();
    const [examesReaproveitamento, setExamesReaproveitamento] = useState([]);
    const [examesExcluidos, setExamesExcluidos] = useState([]);
    const [riscosReaproveitamento, setRiscosReaproveitamento] = useState([]);
    const [celular, setCelular] = useState("");
    const [cpf, setCpf] = useState("");
    const [nomeFdt, setNomeFdt] = useState("");
    const [nomeGhe, setNomeGhe]: any = useState('');;
    const [uf, setUf]: any = useState('');
    const [crm, setCRM]: any = useState('');
    const [nomeMedico, setNomeMedico]: any = useState('');
    const [tipoConsulta, setTipoConsulta]: any = useState('');
    const [trabalhoAltura, setTrabalhoAltura]: any = useState('');
    const [trabalhoConfinado, setTrabalhoConfinado]: any = useState('');
    const [valorPago, setValorPago]: any = useState()
    const [openPdfModal, setOpenPdfModal] = useState(false);
    const [isDocumentAccessible, setIsDocumentAccessible] = useState(false);
    const [categorias, setCategorias] = useState([])
    const [categoriaSelecionada, setCategoriaSelecionada]: any = useState()
    const [nomeRisco, setNomeRisco]: any = useState()
    const [qrCodeUrl, setQrCodeUrl] = useState('');
    const contentRef = useRef(null);

    const navigate = useNavigate();

    // const qrCodeUrl = 'https://www.criarmeme.com.br/meme/meme-57281-Parabens-Voce-e-um--otimo-curioso.jpg';

    useEffect(() => {
        const fetchData = async () => {
            try {
                await loadReaproveitamento()
                await loadExames()
                await handleListCategory()
            } catch (error) {
                console.error('Erro ao buscar os dados:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    // Método para buscar os exames do vinculados ao indexAso
    const loadExames = async () => {
        try {
            const { data } = await api.get(`buscar-itens-reaproveitamento-empresa/${indexAso}`);
            setExamesReaproveitamento(data.exames);
            setExamesExcluidos(data.examesExcluidos);
            setRiscosReaproveitamento(data.riscos);
        } catch (error) {
            console.error(error);
        }
    };

    // Método para buscar os dados do reaproveitamento
    const loadReaproveitamento = async () => {
        try {
            const { data } = await api.get(`reaproveitamento/${indexAso}`);
            const reaproveitamento = data.reaproveitamento;
            const cnae = data.cnae;

            setReaproveitamento(reaproveitamento);
            setIdArquivo(reaproveitamento.id_arquivo);
            setLiberado(reaproveitamento.liberado)
            setAssinadoTrabalhador(reaproveitamento.assinado_trabalhador)

            setNomeFdt(reaproveitamento.frente_de_trabalho || 'Não adicionada');
            setNomeGhe(reaproveitamento.ghe || 'Não adicionada');
            setTrabalhador(reaproveitamento.pgrTrabalhador);
            setEmpresa(reaproveitamento.empresa);

            setCpf(reaproveitamento.pgrTrabalhador?.cpf || '');
            setCelular(reaproveitamento.pgrTrabalhador?.celular || '');

            setFuncaoAtribuida(reaproveitamento.funcao);
            setTipoConsulta(reaproveitamento.tipo_consulta);
            setTrabalhoAltura(reaproveitamento.trabalho_altura);
            setTrabalhoConfinado(reaproveitamento.trabalho_confinado);

            setNomeMedico(reaproveitamento.nome_medico);
            setCRM(reaproveitamento.crm_medico);
            setUf(reaproveitamento.uf_crm);

            setValorPago(reaproveitamento.valor_pago);

            setCnae(cnae)


        } catch (error) {
            console.error(error);
        }
    };

    const handleListCategory = async () => {
        try {
            const response = await api.get('buscar-categorias-riscos');
            const responseData = response.data;

            const formattedData = responseData.map((item: { id: number; categoria: string }) => ({
                id: item.id,
                categoria: item.categoria
            }));

            setCategorias(formattedData);

            // Define a primeira categoria como selecionada
            if (formattedData.length > 0) {
                setCategoriaSelecionada(formattedData[0].id); // Define o 'id' da primeira categoria
            }
        } catch (error) {
            console.error('Erro ao buscar categorias', error);
            setAlert({ show: true, message: 'Erro ao buscar categorias. Tente novamente!', variant: 'danger' });
        } finally {
            setIsLoading(false);
        }
    };


    // Método para salvar e liberar o reaproveitamento
    const handleSubmit = async () => {
        try {
            const data = {
                reaproveitamento: reaproveitamento,
                trabalhador: trabalhador,
                funcao: funcaoAtribuida,
                nomeFdt: nomeFdt,
                nomeGhe: nomeGhe,
                cpf: cpf,
                celular: celular,
                tipoConsulta: tipoConsulta,
                trabalhoAltura: trabalhoAltura,
                trabalhoConfinado: trabalhoConfinado,
                nomeMedico: nomeMedico,
                crmMedico: crm,
                ufCrm: uf,
            }
            const response = await api.post('liberar-reaproveitamento-empresa', { data })
            if (response.status === 200) {
                handleOpenPdf()
            }
        } catch (error) {
            console.error(error)
            throw error;
        }
    }

    // Método para salvar o pdf final no bucket e enviar para assinatura
    const handleSendPdf = async () => {
        setIsSubmitting(true);
        try {
            const pdfBytes = await generatePDF();
            const nomeDoPdf = `ASO-APROVEITAMENTO_${indexAso}_${trabalhador.nome}.pdf`;
            const data = {
                idEmpresa: empresa.id,
                nomeDoPdf: nomeDoPdf,
                pdfBytes: Array.from(new Uint8Array(pdfBytes)),
                idReaproveitamento: indexAso,
                idTrabalhador: trabalhador.id
            }
            const response = await api.post('upload-documento-reaproveitamento', data)
            if (response.status == 200) {
                setLiberado(true);
                setTimeout(() => {
                    navigate('/reaproveitamentos');
                }, 1000);
            }
        }
        catch (error) {
            console.error(error);
            throw error;
        } finally {
            setIsSubmitting(false);
        }
    }

    const generatePDF = async () => {
        const content: any = contentRef.current;

        if (!content) {
            console.error('Content ref is null. Make sure the component has rendered.');
            return;
        }

        const doc: any = new jsPDF();
        const pages = content.querySelectorAll('.page');

        if (pages) {
            pages.forEach((element: any) => {
                element.style.backgroundImage = 'none';
            });
        }

        if (pages.length === 0) {
            console.error('No pages found. Make sure the content has a class "page".');
            return;
        }

        for (let i = 0; i < pages.length; i++) {
            const page = pages[i];
            const isLandscape = page.classList.contains('landscape');
            const orientation = isLandscape ? 'landscape' : 'portrait';

            if (i > 0) {
                doc.addPage([297, 210], orientation);
            }

            const canvas = await html2canvas(page, { scale: 1 });
            const imgData = canvas.toDataURL('image/jpeg');
            doc.addImage(imgData, 'JPEG', 0, 0);
        }

        const pdfBytes = doc.output('arraybuffer');

        if (!pdfBytes) {
            console.error('Failed to generate PDF bytes.');
        } else {
            console.log('PDF bytes generated successfully.');
        }

        return pdfBytes;
    };

    // Método para buscar as funções do AutoComplete
    const handleListFunction = async (inputValue: any) => {
        if (inputValue.length > 3) {
            const response = await api.get(`funcionarios/buscar-funcao/${inputValue}`);
            const responseData = response.data;
            setFuncoes(responseData);
        } else {
            setFuncoes([]);
        }
    };

    // Método para buscar os exames do AutoComplete
    const handleListExams = async (inputValue: any) => {
        if (inputValue.length >= 3) {
            const response = await api.get(`listar-base-exames/${inputValue}`);
            setExames(response.data)
        } else {
            setExames([])
        }
    }

    // Método para listar os riscos do AutoComplete
    const handleListRisk = async (inputValue: any) => {
        if (inputValue.length > 3) {
            try {
                const encodedValue = encodeURIComponent(inputValue);
                const response = await api.get(`buscar-riscos/${encodedValue}`);
                setRiscos(response.data);
            } catch (error) {
                console.error('Erro ao buscar riscos', error);
                setAlert({ show: true, message: 'Erro ao buscar riscos. Tente novamente!', variant: 'danger' });
            } finally {
                setIsLoading(false);
            }
        } else {
            setRiscos([]);
        }
    };

    // Método chamado o botão de adicionar o exame é chamado
    const handleAddExame = () => {
        if (mostrarNovoExame) {
            setMostrarNovoExame(false)
        } else {
            setMostrarNovoExame(true);
        }
    };

    // Método chamado pelo botão de adicionar risco - Mostra os campos de input para adição
    const handleAddRisk = () => {
        if (mostrarNovoRisco) {
            setMostrarNovoRisco(false)
        } else {
            setMostrarNovoRisco(true)
        }
    }

    const handleNovoExameChange = (field: string, value: string) => {
        setNovoExame({ ...novoExame, [field]: value });
    };


    const handleOpenModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleConfirmSubmit = () => {
        setShowModal(false);
        handleSubmit();
    };


    // Método para salvar um novo exame adicionado
    const handleSaveExame = async () => {
        try {
            const data = {
                indexAso: indexAso,
                id_arquivo: idArquivo,
                id_exame: exameSelecionado.id,
                id_trabalhador: trabalhador.id,
                valor_total: parseStringToNumber(novoExame.valor_total),
                data_realizacao: novoExame.data_realizacao

            }
            const response = await api.post(`salvar-exame-reaproveitamento-empresa`, data)
            if (response.status === 200) {
                clearExam()
                setMostrarNovoExame(false);
                await loadExames();
            } else {
                setAlert({
                    show: true,
                    message: "Ocorreu um erro. Não foi possível salvar o exame.",
                    variant: "danger",
                });
            }
        } catch (error) {
            console.error(error)
        }
    };

    // Método para deletar um exame - Adiciona um deleted_at nele
    const handleDeleteExam = async (id_exame: number) => {
        try {
            const response = await api.post(`exluir-exame-reaproveitamento-empresa/${id_exame}`)
            if (response.status === 200) {
                loadExames()
            } else {
                setAlert({
                    show: true,
                    message: "Ocorreu um erro. Não foi possível excluir o exame.",
                    variant: "danger",
                });
            }
        } catch (error) {
            console.error(error)
            throw error;
        }
    }

    // Método para que seja adicionado exame que havia sido excluído pela empresa
    const handleAddRemovedExam = async (id_exame: number) => {
        try {
            const response = await api.post(`adicionar-exame-excluido-empresa/${id_exame}`)
            if (response.status === 200) {
                loadExames()
            } else {
                setAlert({
                    show: true,
                    message: "Ocorreu um erro. Não foi possível adicionar o exame na lista.",
                    variant: "danger",
                });
            }
        } catch (error) {
            console.error(error)
            throw error;
        }
    }

    // Método para recarregar os exames que foram deletados
    const handleRechargeExams = async () => {
        try {
            const response = await api.post(`recarregar-exames-excluidos-editar-empresa/${indexAso}`);
            if (response.status == 200) {
                loadExames()
            } else {
                setAlert({
                    show: true,
                    message: "Ocorreu um erro. Não foi possível recarregar os exames.",
                    variant: "danger",
                });
            }
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    const handleSaveRisk = async () => {
        try {
            const categoria: any = categorias.find((cat: any) => cat.id === parseInt(categoriaSelecionada));

            if (!categoria) {
                setAlert({ show: true, message: 'Categoria selecionada é inválida!', variant: 'warning' });
                return;
            }

            const riscoDuplicado = riscosReaproveitamento.find((risco: any) =>
                risco.nome_risco === nomeRisco && risco.id_categoria === categoria.id
            );

            if (riscoDuplicado) {
                setAlert({
                    show: true,
                    message: "Já existe um risco com esse nome e categoria.",
                    variant: "warning",
                });
                return;
            }

            const data = {
                indexAso: indexAso,
                idArquivo: idArquivo,
                nomeRisco: nomeRisco,
                categoria: categoria,
                idTrabalhador: trabalhador.id,
            };

            const response = await api.post(`salvar-risco-reaproveitamento-empresa`, data);
            if (response.status === 200) {
                loadExames();
                setMostrarNovoRisco(false);
                clearRisk();
            } else {
                setAlert({
                    show: true,
                    message: "Ocorreu um erro. Não foi possível recarregar os exames.",
                    variant: "danger",
                });
            }
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    // Método para deletar um exame - Adiciona um deleted_at nele
    const handleDeleteRisk = async (id_risco: number) => {
        try {
            const response = await api.post(`exluir-risco-reaproveitamento-empresa/${id_risco}`)
            if (response.status === 200) {
                loadExames()
            } else {
                setAlert({
                    show: true,
                    message: "Ocorreu um erro. Não foi possível excluir o risco.",
                    variant: "danger",
                });
            }
        } catch (error) {
            console.error(error)
            throw error;
        }
    }

    // Método para limpar o campo de novo exame
    const clearExam = () => {
        setExameSelecionado('')
        novoExame.nome = ''
        novoExame.data_realizacao = ''
        novoExame.valor_total = ''
    }

    const handleClosePdf = () => setOpenPdfModal(false);

    const handleOpenPdf = async () => {
        setOpenPdfModal(true);
    };

    const clearRisk = () => {
        setNomeRisco('')
    }

    const style = {
        position: 'absolute',
        top: '80%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 1123,
        height: 1123,
    };

    const tipos = [
        { id: 1, nome: 'APTO' },
        { id: 2, nome: 'INAPTO' },
        { id: 3, nome: 'NÃO SE APLICA' }
    ];

    const tiposconsulta = [
        { id: '1', nome: 'ADMISSIONAL' },
        { id: '2', nome: 'PERIÓDICO' },
    ];

    // Método para formatar a validade dos exames - Formato Date para String
    const formatarDataValidade = (data: string) => {
        return DateTime.fromISO(data).toFormat('dd/MM/yyyy');
    }


    // Método para exibição da data de realização do exame no PDF
    const subtrairNoveMeses = (data: string): string => {
        const dataLuxon = DateTime.fromISO(data);

        if (!dataLuxon.isValid) {
            throw new Error('Data inválida');
        }

        const novaData = dataLuxon.minus({ months: 9 }).set({ day: Math.min(dataLuxon.day, dataLuxon.minus({ months: 9 }).daysInMonth) });

        return novaData.toFormat('dd/MM/yyyy');
    };

    // Formatar Data do documento
    const formatarData = (data: string) => {
        if (!data) return '';
        const isFormatted = data.includes('/');
        if (isFormatted) {
            return data;
        } else {
            const [ano, mes, dia] = data.split('-');
            return `${dia}/${mes}/${ano}`;
        }
    };

    // Método para transformar o preço do exame - Formato BigInt para Locale BR
    const transformarPreco = (valor: any) => {
        const valorDividido = valor / 100;
        return valorDividido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    const parseStringToNumber = (input: string): number => {
        const trimmedInput = input.trim();
        const cleanedInput = trimmedInput.replace(/[.,]/g, '');
        const result = parseFloat(cleanedInput);
        if (isNaN(result)) {
            throw new Error('A string fornecida não pode ser convertida em um número.');
        }
        return result;
    }

    useEffect(() => {
        setQrCodeUrl(`https://webhomol.meupgr.com.br/informacoes-documento-empresa/${empresa?.id}/trabalhador/${reaproveitamento?.pgrTrabalhador?.id}/doc/${reaproveitamento?.id}`)
    }, [empresa, reaproveitamento]);

    const determinarAptidao = (trabalhoAltura: number, trabalhoConfinado: number) => {
        const status = [trabalhoAltura, trabalhoConfinado];

        const counts = {
            apto: status.filter(value => value === 1).length,
            inapto: status.filter(value => value === 2).length,
            na: status.filter(value => value === 3).length,
        };

        if (counts.apto > counts.inapto) return "APTO";
        if (counts.inapto > counts.apto) return "INAPTO";
        return "APTO"; // Considera APTO em caso de empate ou N/A
    };

    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='../../' />
            <Main>
                <Card style={{
                    border: '1px solid #0d6efd',
                    borderRadius: '8px',
                    margin: '10px'
                }}>
                    <CardContent>
                        <div>
                            <div style={{ display: 'flex' }}>
                                <ArrowLeft
                                    size={24}
                                    color="#0d6efd" // Mesma cor do botão primary
                                    style={{ cursor: 'pointer', marginRight: '8px' }}
                                    onClick={() => navigate('/reaproveitamentos')}
                                />
                                <span
                                    style={{
                                        color: '#0d6efd',
                                        fontSize: '16px',
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => navigate('/reaproveitamentos')}
                                >
                                    Voltar
                                </span>
                            </div>
                            <hr />
                            <Title text="Liberar ASO Rápido" />
                        </div>
                        <Row style={{ marginTop: '20px' }}>
                            <h6 style={{ color: '#0463C1', marginRight: '5px' }}>Empresa: {empresa ? empresa.nome : ''} </h6>
                        </Row>
                        <hr />
                        <Row style={{ marginTop: '20px' }}>
                            <h6 style={{ color: '#0463C1', marginRight: '5px' }}>Informações do Trabalhador(a)</h6>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Form.Group controlId="formNome" className="mb-2">
                                    <Form.Label>Nome do Funcionário</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="nome"
                                        value={trabalhador?.nome || ''}
                                        disabled
                                        size="sm"
                                        style={{
                                            padding: '0.2rem 0.4rem',
                                            fontSize: '1rem'
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="formFuncao" className="mb-2">
                                    <Form.Label>Função atribuída</Form.Label>
                                    <Autocomplete
                                        freeSolo
                                        options={funcoes}
                                        getOptionLabel={(option) => option.nome || ''}
                                        value={funcaoAtribuida || null}
                                        disabled={liberado}
                                        onInputChange={(event, newInputValue) => handleListFunction(newInputValue)}
                                        onChange={(event, newValue) => setFuncaoAtribuida(newValue)}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                name="funcaoAtribuida"
                                                size="small"
                                                style={{
                                                    padding: '0.2rem 0.4rem',
                                                    fontSize: '1rem',
                                                    bottom: '5px',
                                                    right: '6px'
                                                }}
                                            />
                                        )}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col md={6}>
                                <Form.Group controlId="formCpf">
                                    <Form.Label>CPF</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="cpf"
                                        value={cpf}
                                        disabled={liberado}
                                        onChange={(e) => {
                                            setCpf(e.target.value);
                                        }}
                                        size="sm"
                                        style={{
                                            padding: '0.2rem 0.4rem',
                                            fontSize: '1rem'
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="formCelular" className="mb-2">
                                    <Form.Label>Celular</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="celular"
                                        value={celular}
                                        disabled={liberado}
                                        onChange={(e) => {
                                            setCelular(e.target.value);
                                        }}
                                        size="sm"
                                        style={{
                                            padding: '0.2rem 0.4rem',
                                            fontSize: '1rem'
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '20px' }}>
                            <h6 style={{ color: '#0463C1', marginRight: '5px' }}>Frente de Trabalho e Consultas</h6>
                        </Row>
                        <Row className="mb-2">
                            <Col md={3}>
                                <Form.Group controlId="formFrente">
                                    <Form.Label>Frente de Trabalho</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="frente-trabalho"
                                        value={nomeFdt}
                                        disabled={liberado}
                                        onChange={(e) => {
                                            setNomeFdt(e.target.value);
                                        }}
                                        size="sm"
                                        style={{
                                            padding: '0.2rem 0.4rem',
                                            fontSize: '1rem'
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group controlId="formGhe" className="mb-2">
                                    <Form.Label>GHE</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="ghe"
                                        value={nomeGhe}
                                        disabled={liberado}
                                        onChange={(e) => {
                                            setNomeGhe(e.target.value);
                                        }}
                                        size="sm"
                                        style={{
                                            padding: '0.2rem 0.4rem',
                                            fontSize: '1rem'
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group controlId="formTipoConsulta" className="mb-2">
                                    <Form.Label>Tipo de Consulta</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="tipo-consulta"
                                        value={tipoConsulta}
                                        disabled={liberado}
                                        onChange={(e) => {
                                            setTipoConsulta(e.target.value)
                                        }}
                                        size="sm"
                                        style={{
                                            padding: '0.2rem 0.4rem',
                                            fontSize: '1rem',
                                            height: '2.2rem', // Ajuste a altura conforme necessário
                                        }}
                                    >
                                        {tiposconsulta.map((tipo) => (
                                            <option key={tipo.id} value={tipo.id}>
                                                {tipo.nome}
                                            </option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group controlId="formAltura" className="mb-2">
                                    <Form.Label>Trabalho em Altura</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="trabalho-altura"
                                        value={trabalhoAltura}
                                        disabled={liberado}
                                        onChange={(e) => {
                                            setTrabalhoAltura(e.target.value)
                                        }}
                                        size="sm"
                                        style={{
                                            padding: '0.2rem 0.4rem',
                                            fontSize: '1rem'
                                        }}
                                    >
                                        {tipos.map((tipo) => (
                                            <option key={tipo.id} value={tipo.id}>
                                                {tipo.nome}
                                            </option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group controlId="formConfinado" className="mb-2">
                                    <Form.Label>Espaço Confinado</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="trabalho-confinado"
                                        value={trabalhoConfinado}
                                        disabled={liberado}
                                        onChange={(e) => {
                                            setTrabalhoConfinado(e.target.value)
                                        }}
                                        size="sm"
                                        style={{
                                            padding: '0.2rem 0.4rem',
                                            fontSize: '1rem'
                                        }}
                                    >
                                        {tipos.map((tipo) => (
                                            <option key={tipo.id} value={tipo.id}>
                                                {tipo.nome}
                                            </option>
                                        ))}
                                    </Form.Control>

                                </Form.Group>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '20px' }}>
                            <h6 style={{ color: '#0463C1', marginRight: '5px' }}>Médico coordenador</h6>
                        </Row>
                        <Row className="mb-2">
                            <Col md={4}>
                                <Form.Group controlId="formNomeMedico">
                                    <Form.Label>Nome do médico</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="nome-medico"
                                        value={nomeMedico}
                                        disabled={liberado}
                                        onChange={(e) => {
                                            setNomeMedico(e.target.value)
                                        }}
                                        size="sm"
                                        style={{
                                            padding: '0.2rem 0.4rem',
                                            fontSize: '1rem'
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group controlId="formCrmMedico">
                                    <Form.Label>CRM</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="crm-medico"
                                        value={crm}
                                        disabled={liberado}
                                        onChange={(e) => {
                                            setCRM(e.target.value)
                                        }}
                                        size="sm"
                                        style={{
                                            padding: '0.2rem 0.4rem',
                                            fontSize: '1rem'
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group controlId="formUfCrmMedico">
                                    <Form.Label>UF do CRM</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="uf-crm-medico"
                                        value={uf}
                                        disabled={liberado}
                                        onChange={(e) => {
                                            setUf(e.target.value)
                                        }}
                                        size="sm"
                                        style={{
                                            padding: '0.2rem 0.4rem',
                                            fontSize: '1rem'
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </CardContent>
                </Card>
                <Row className="mb-2">
                    <Col md={6}>
                        <Card style={{
                            height: '500px',
                            border: '1px solid #0d6efd',
                            borderRadius: '8px',
                            margin: '10px'
                        }}>
                            <Card.Body style={{ overflowY: 'auto' }}>
                                <Row className="mb-3">
                                    <Col>
                                        <Card.Title>Exames</Card.Title>
                                    </Col>
                                    {/* <Col className="text-end">
                                        <Button variant="primary" size="sm">
                                            Exames da função selecionada
                                        </Button>
                                    </Col> */}
                                </Row>
                                <hr />
                                <Row className="mb-2">
                                    <Col md={11}>
                                        {!liberado && (
                                            <Button variant="success" size="sm" onClick={handleAddExame}>
                                                <Plus /> Adicionar exame
                                            </Button>
                                        )}

                                    </Col>
                                    <Col md={1} className="d-flex justify-content-center align-items-center">
                                        {!liberado && (
                                            <Button size='sm' onClick={() => handleRechargeExams()}>
                                                <Refresh style={{ cursor: 'pointer' }} />
                                            </Button>
                                        )}
                                    </Col>
                                </Row>

                                {mostrarNovoExame && (
                                    <Row className="mb-1">
                                        <Col md={6}>
                                            <Form.Group controlId="formNovoExameNome">
                                                <Autocomplete
                                                    options={exames}
                                                    getOptionLabel={(option: any) => option ? option.nome : ""}
                                                    value={exameSelecionado}
                                                    onChange={(event: any, newValue: any) => {
                                                        setExameSelecionado(newValue);
                                                    }}
                                                    onInputChange={(event, inputValue) => {
                                                        handleListExams(inputValue);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            size="small"
                                                            style={{
                                                                padding: '0.2rem 0.4rem',
                                                                fontSize: '0.75rem'
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group controlId="formNovoExameData">
                                                <InputMask
                                                    mask="99/99/9999"
                                                    value={novoExame.data_realizacao}
                                                    onChange={(e: any) => handleNovoExameChange('data_realizacao', e.target.value)}
                                                    maskChar=" " // Caractere substituto da máscara, você pode usar um espaço ou outro caractere
                                                >
                                                    {(inputProps: any) => (
                                                        <TextField
                                                            {...inputProps}
                                                            type="text"
                                                            placeholder="Data de Realização"
                                                            size="small"
                                                            style={{
                                                                padding: '0.2rem 0.4rem',
                                                                fontSize: '0.75rem'
                                                            }}
                                                        />
                                                    )}
                                                </InputMask>
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            <Form.Group controlId="formNovoExameValor">
                                                <TextField
                                                    type="text"
                                                    placeholder="Valor"
                                                    value={novoExame.valor_total}
                                                    onChange={(e) => handleNovoExameChange('valor_total', e.target.value)}
                                                    size="small"
                                                    style={{
                                                        padding: '0.2rem 0.4rem',
                                                        fontSize: '0.75rem'
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={1} className="d-flex align-items-center justify-content-center">
                                            <Button
                                                variant="success"
                                                aria-label="Salvar exame"
                                                size="sm"
                                                onClick={handleSaveExame}
                                                style={{
                                                    padding: '0.2rem 0.4rem',
                                                    fontSize: '0.75rem',
                                                    marginRight: '0.4rem'
                                                }}
                                            >
                                                Adicionar
                                            </Button>
                                        </Col>
                                    </Row>
                                )}

                                <Row className="mb-2">
                                    <Col md={6}>
                                        <Form.Label>Nome do Exame</Form.Label>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Label>Data de Validade</Form.Label>
                                    </Col>
                                    <Col md={2}>
                                        <Form.Label>Valor</Form.Label>
                                    </Col>
                                </Row>

                                {examesReaproveitamento.map((exame: any, index: any) => (
                                    <Row key={index} className="mb-1">
                                        <Col md={6}>
                                            <Form.Group controlId={`formExameNome-${index}`}>
                                                <Form.Control
                                                    type="text"
                                                    name={`exameNome-${index}`}
                                                    value={exame.exame.nome || ''}
                                                    disabled
                                                    size="sm"
                                                    style={{ fontSize: '0.8rem' }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group controlId={`formExameData-${index}`}>
                                                <Form.Control
                                                    type="text"
                                                    name={`exameData-${index}`}
                                                    value={formatarDataValidade(exame.data_validade) || ''}
                                                    disabled
                                                    size="sm"
                                                    style={{ fontSize: '0.8rem' }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            <Form.Group controlId={`formExameValor-${index}`}>
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id={`tooltip-exame-valor-${index}`}>
                                                            Valor referente à tabela balcão da empresa
                                                        </Tooltip>
                                                    }
                                                >
                                                    <Form.Control
                                                        type="text"
                                                        name={`exameValor-${index}`}
                                                        value={transformarPreco(exame.valor) || ''}
                                                        disabled
                                                        size="sm"
                                                        style={{ fontSize: '0.8rem' }}
                                                    />
                                                </OverlayTrigger>
                                            </Form.Group>
                                        </Col>
                                        <Col md={1} className="d-flex align-items-center justify-content-center">
                                            {!liberado && (
                                                <Button
                                                    variant="danger"
                                                    aria-label="Excluir exame"
                                                    onClick={() => handleDeleteExam(exame.id)}
                                                    size="sm"
                                                    style={{
                                                        padding: '0.2rem 0.4rem',
                                                        fontSize: '0.75rem'
                                                    }}
                                                >
                                                    <Trash />
                                                </Button>
                                            )}
                                        </Col>
                                    </Row>
                                ))}
                                <hr />
                                <Row className="mb-2">
                                    <Col md={6}>
                                        <Form.Label>Exames retirados pela empresa</Form.Label>
                                    </Col>
                                </Row>
                                {examesExcluidos.map((exame: any, index: any) => (
                                    <Row key={index} className="mb-1">
                                        <Col md={6}>
                                            <Form.Group controlId={`formExameNome-${index}`}>
                                                <Form.Control
                                                    type="text"
                                                    name={`exameNome-${index}`}
                                                    value={exame.exame.nome || ''}
                                                    disabled
                                                    size="sm"
                                                    style={{
                                                        fontSize: '0.8rem',
                                                        borderColor: 'red',
                                                        backgroundColor: '#f8f9fa'
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group controlId={`formExameData-${index}`}>
                                                <Form.Control
                                                    type="text"
                                                    name={`exameData-${index}`}
                                                    value={formatarDataValidade(exame.data_validade) || ''}
                                                    disabled
                                                    size="sm"
                                                    style={{ fontSize: '0.8rem' }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            <Form.Group controlId={`formExameValor-${index}`}>
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id={`tooltip-exame-valor-${index}`}>
                                                            Valor referente à tabela balcão da empresa
                                                        </Tooltip>
                                                    }
                                                >
                                                    <Form.Control
                                                        type="text"
                                                        name={`exameValor-${index}`}
                                                        value={transformarPreco(exame.valor) || ''}
                                                        disabled
                                                        size="sm"
                                                        style={{ fontSize: '0.8rem' }}
                                                    />
                                                </OverlayTrigger>
                                            </Form.Group>
                                        </Col>
                                        <Col md={1} className="d-flex align-items-center justify-content-center">
                                            {!liberado && (
                                                <Button
                                                    variant="primary"
                                                    aria-label="Adicionar exame"
                                                    size="sm"
                                                    onClick={() => handleAddRemovedExam(exame.id)}
                                                    style={{
                                                        padding: '0.2rem 0.4rem',
                                                        fontSize: '0.75rem'
                                                    }}
                                                >
                                                    <ArrowUpwardIcon style={{
                                                        fontSize: '1rem'
                                                    }} />
                                                </Button>
                                            )}
                                        </Col>
                                    </Row>
                                ))}
                                <hr />
                                <Row className="justify-content-center">
                                    <Col xs="auto">
                                        <h6 style={{ marginRight: '5px', fontWeight: 'bold' }}>Pagamento efetuado: R$ {valorPago}</h6>
                                    </Col >
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={6}>
                        <Card style={{
                            height: '500px',
                            border: '1px solid #0d6efd',
                            borderRadius: '8px',
                            margin: '10px'
                        }}>
                            <Card.Body style={{ overflowY: 'auto' }}>
                                <Row className="mb-3">
                                    <Col>
                                        <Card.Title>Riscos</Card.Title>
                                    </Col>
                                    {/* <Col className="text-end">
                                        <Button variant="primary" size="sm">
                                            Riscos da função selecionada
                                        </Button>
                                    </Col> */}
                                </Row>
                                <hr />
                                <Row className="mb-2">
                                    <Col md={6}>
                                        {!liberado && (
                                            <Button variant="success" size="sm" onClick={handleAddRisk}>
                                                <Plus /> Adicionar risco
                                            </Button>
                                        )}
                                    </Col>
                                </Row>

                                {mostrarNovoRisco && (
                                    <Row className="mb-2">
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>Categoria</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    id="categoriaSelecionada"
                                                    value={categoriaSelecionada}
                                                    onChange={(e: any) => setCategoriaSelecionada(e.target.value)}
                                                    style={{
                                                        height: '40px', width: '100%', padding: '0.2rem 0.4rem',
                                                        fontSize: '1rem'
                                                    }}
                                                >
                                                    {categorias.map((categoria: any) => (
                                                        <option
                                                            key={categoria.id}
                                                            value={categoria.id}
                                                        >
                                                            {categoria.categoria}
                                                        </option>
                                                    ))}
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group controlId="formNomeRisco">
                                                <Form.Label>Nome</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="nome-risco"
                                                    value={nomeRisco}
                                                    onChange={(e) => {
                                                        setNomeRisco(e.target.value)
                                                    }}
                                                    size="sm"
                                                    style={{
                                                        padding: '0.2rem 0.4rem',
                                                        fontSize: '1rem',
                                                        height: '40px',
                                                        width: '100%'
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={2} className="d-flex align-items-center justify-content-center">
                                            <Button
                                                variant="success"
                                                aria-label="Salvar risco"
                                                size="sm"
                                                onClick={handleSaveRisk}
                                                style={{
                                                    padding: '0.2rem 0.4rem',
                                                    fontSize: '0.75rem',
                                                    marginRight: '0.4rem',
                                                    marginTop: '30px'
                                                }}
                                            >
                                                Adicionar
                                            </Button>
                                        </Col>
                                    </Row>
                                )}

                                <Row className="mb-2">
                                    <Col md={3}>
                                        <Form.Label>Categoria</Form.Label>
                                    </Col>
                                    <Col md={8}>
                                        <Form.Label>Risco</Form.Label>
                                    </Col>
                                </Row>
                                {riscosReaproveitamento.map((risco: any, index: any) => (
                                    <Row key={index} className="mb-1">
                                        <Col md={3}>
                                            <Form.Group controlId={`formExameNome-${index}`}>
                                                <Form.Control
                                                    type="text"
                                                    name={`exameNome-${index}`}
                                                    value={risco.categoria || ''}
                                                    disabled
                                                    size="sm"
                                                    style={{ fontSize: '0.8rem' }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={8}>
                                            <Form.Group controlId={`formExameData-${index}`}>
                                                <Form.Control
                                                    type="text"
                                                    name={`exameData-${index}`}
                                                    value={risco.nome_risco || ''}
                                                    disabled
                                                    size="sm"
                                                    style={{ fontSize: '0.8rem' }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={1} className="d-flex align-items-center justify-content-center">
                                            {!liberado && (
                                                <Button
                                                    variant="danger"
                                                    aria-label="Excluir risco"
                                                    onClick={() => handleDeleteRisk(risco.id)}
                                                    size="sm"
                                                    style={{
                                                        padding: '0.2rem 0.4rem',
                                                        fontSize: '0.75rem'
                                                    }}
                                                >
                                                    <Trash />
                                                </Button>
                                            )}
                                        </Col>
                                    </Row>
                                ))}
                                <hr />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Modal
                    id="modal-pdf"
                    open={openPdfModal}
                    onClose={handleClosePdf}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    style={{ overflow: 'auto' }}
                    className={`${isDocumentAccessible ? 'teste' : 'planoModal'}`}
                    slotProps={{
                        backdrop: {
                            style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' }
                        }
                    }}
                >
                    <Box sx={style}>
                        <div ref={contentRef} id="content-pdf">
                            <div className="page">
                                <div className="page-content capa">
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <div style={{ width: '300px', border: '0.5px solid #C0C0C0' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                                                <img src={Logo} alt="logo" style={{ width: '95%', height: '60px', marginTop: '10px', padding: '5px' }} />
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                                                <p style={{ fontSize: '11px', margin: 0 }}>ATENTO MEDICINA DO TRABALHO LTDA</p>
                                                <p style={{ fontSize: '10px', margin: 0 }}>CNPJ 11.509.053/0001-59</p>
                                                <p style={{ fontSize: '9px', margin: 0 }}>41 3642-6495</p>
                                                <p style={{ fontSize: '8px', margin: 0 }}>Rua Heitor Alves Guimarães, 495 - ARAUCÁRIA - PARANÁ</p>
                                            </div>
                                        </div>
                                        <div style={{ flex: 1, border: '0.5px solid #C0C0C0', borderLeft: 'none' }}>
                                            <p style={{ fontSize: '8px', margin: '1px' }}>
                                                ESTE DOCUMENTO ATENDE ÁS EXIGÊNCIAS DA NR-7, APROVADAS PELA PORTARIA Nº3.214, DE 8 DE JUNHO DE 1978,
                                                3164/82,12/83,24/94 E 08/96 DO MINISTÉRIO DO TRABALHO E EMPREGO PARA FINS DE EXAME.
                                            </p>
                                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', width: '70%' }}>
                                                    <p style={{ fontSize: '11px', margin: 0 }}><b>ATESTADO DE SAÚDE OCUPACIONAL (Nº 17)</b></p>
                                                    <p style={{ fontSize: '11px', margin: 0 }}><b>{tipoConsulta}</b></p>
                                                    <p style={{ fontSize: '10px', margin: 0 }}>
                                                        ASO Gerado por reaproveitamento de exames
                                                    </p>
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '30%' }}>
                                                    <QRCode value={qrCodeUrl} size={110} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* DIV PRINCIPAL */}
                                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%', border: '0.5px solid #C0C0C0', borderTop: 'none' }}>
                                        <div style={{ display: 'flex', width: '23%', flexDirection: 'column' }}>
                                            <p style={{ fontSize: '10px', margin: '2px', marginLeft: '5px' }}><b>EMPRESA:</b></p>
                                            <p style={{ fontSize: '10px', margin: '2px', marginLeft: '5px' }}><b>ENDEREÇO:</b></p>
                                            <p style={{ fontSize: '10px', margin: '2px', marginLeft: '5px' }}><b>RAMO DE ATIVIDADE:</b></p>
                                            <p style={{ fontSize: '10px', margin: '2px', marginLeft: '5px' }}><b>GRAU DE RISCO:</b></p>
                                        </div>
                                        <div style={{ display: 'flex', width: '77%', flexDirection: 'column' }}>
                                            {empresa && (
                                                <>
                                                    <p style={{ fontSize: '10px', margin: '2px' }}>{empresa.nome} <b style={{ marginLeft: '15px' }}>CNPJ: </b>{empresa.cnpj} </p>
                                                    <p style={{ fontSize: '10px', margin: '2px' }}>{empresa.endereco} - {empresa.numero}</p>
                                                    <p style={{ fontSize: '8px', margin: '2px' }}>{cnae.cnae} - {cnae.nome}</p>
                                                    <p style={{ fontSize: '10px', margin: '2px' }}>{cnae.g_risco}</p>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    {/* DIV PRINCIPAL */}
                                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%', border: '0.5px solid #C0C0C0', borderTop: 'none' }}>
                                        <div style={{ display: 'flex', width: '23%', flexDirection: 'column' }}>
                                            <p style={{ fontSize: '10px', margin: '1px', marginLeft: '5px' }}><b>TRABALHADOR(a):</b></p>
                                            <p style={{ fontSize: '10px', margin: '1px', marginLeft: '5px' }}><b>CPF:</b></p>
                                            <p style={{ fontSize: '10px', margin: '1px', marginLeft: '5px' }}><b>DATA DE NASCIMENTO:</b></p>
                                            <p style={{ fontSize: '10px', margin: '1px', marginLeft: '5px' }}><b>FUNÇÃO:</b></p>
                                            <p style={{ fontSize: '10px', margin: '1px', marginLeft: '5px' }}><b>GHE (SETOR):</b></p>
                                            <p style={{ fontSize: '10px', margin: '1px', marginLeft: '5px' }}><b>FRENTE DE TRABALHO:</b></p>
                                        </div>
                                        <div style={{ display: 'flex', width: '77%', flexDirection: 'column' }}>
                                            {trabalhador && (
                                                <>
                                                    <p style={{ fontSize: '10px', margin: '1px' }}>{trabalhador.nome}</p>
                                                    <p style={{ fontSize: '10px', margin: '1px' }}>{trabalhador.cpf} <b style={{ marginLeft: '15px' }}>RG: </b>123456123 <b style={{ marginLeft: '15px' }}>SEXO: </b> MASCULINO</p>
                                                    <p style={{ fontSize: '10px', margin: '1px' }}>28/05/1998 <b style={{ marginLeft: '15px' }}>IDADE: </b> 26 anos</p>
                                                    <p style={{ fontSize: '8px', margin: '1px' }}>{funcaoAtribuida ? funcaoAtribuida.nome : 'null'}</p>
                                                    <p style={{ fontSize: '10px', margin: '1px' }}>{nomeGhe}</p>
                                                    <p style={{ fontSize: '10px', margin: '1px' }}>{nomeFdt}</p></>
                                            )}
                                        </div>
                                    </div>
                                    {/* DIV PRINCIPAL */}
                                    <div style={{ width: '100%', border: '0.5px solid #C0C0C0', borderTop: 'none' }}>
                                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                            <thead>
                                                <tr>
                                                    <th colSpan={3} style={{ textAlign: 'left', padding: '5px', fontSize: '10px' }}>
                                                        <b>RISCOS OCUPACIONAIS</b>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {riscosReaproveitamento.map((risco: any, index: number) => (
                                                    <tr key={index}>
                                                        <td style={{ width: '30%', border: '0.5px solid #C0C0C0', padding: '2px', fontSize: '7px' }}>
                                                            {risco.categoria}
                                                        </td>
                                                        <td style={{ width: '70%', border: '0.5px solid #C0C0C0', padding: '2px', fontSize: '7px' }}>
                                                            <ul style={{ margin: '0', paddingLeft: '20px' }}>
                                                                <li>{risco.nome_risco}</li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* DIV PRINCIPAL */}
                                    <div style={{ width: '100%', border: '0.5px solid #C0C0C0', borderTop: 'none' }}>
                                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                                            <thead>
                                                <tr>
                                                    <th colSpan={5} style={{ textAlign: 'left', padding: '5px', fontSize: '10px' }}>
                                                        <b>EXAMES REALIZADOS</b>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Array.from({ length: Math.ceil(examesReaproveitamento.length / 20) }).map((_, rowIndex) => (
                                                    <tr key={rowIndex}>
                                                        {Array.from({ length: 4 }).map((_, colIndex) => {
                                                            const startIndex = rowIndex * 20 + colIndex * 5;
                                                            const hasExams = examesReaproveitamento.slice(startIndex, startIndex + 5).length > 0;
                                                            return hasExams ? (
                                                                <td key={colIndex} style={{ border: '0.5px solid #C0C0C0', fontSize: '7px', padding: '5px', verticalAlign: 'top' }}>
                                                                    {Array.from({ length: 5 }).map((_, subIndex) => {
                                                                        const examIndex = startIndex + subIndex;
                                                                        const exame: any = examesReaproveitamento[examIndex];
                                                                        return (
                                                                            <div key={subIndex} style={{ marginBottom: '5px' }}>
                                                                                {exame ? (
                                                                                    <span>
                                                                                        <b>{subtrairNoveMeses(exame.data_validade)}</b> {exame.exame.nome}
                                                                                    </span>
                                                                                ) : null}
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </td>
                                                            ) : null;
                                                        })}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* DIV PRINCIPAL */}
                                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%', border: '0.5px solid #C0C0C0', borderTop: 'none' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '50%', padding: '10px' }}>
                                            <p style={{ fontSize: '10px', margin: '2px', textAlign: 'center' }}>NOME DO MÉDICO EXAMINADOR COM CRM,</p>
                                            <p style={{ fontSize: '10px', margin: '2px', textAlign: 'center' }}>CARIMBO E ASSINATURA</p>
                                            <p style={{ fontSize: '7px', fontWeight: 'bold', margin: '3px', textAlign: 'center' }}>Assinado digitalmente por: </p>
                                            <p style={{ fontSize: '7px', margin: '1px', textAlign: 'center' }}>MAURICIO CHERATZKI:78083567949</p>
                                            <p style={{ fontSize: '7px', margin: '1px', textAlign: 'center' }}>Autenticado por AC Certisign RFB G5 </p>
                                            <hr style={{ width: '50%', borderColor: 'black', marginTop: '70px', marginBottom: 0 }} />
                                            <p style={{ fontSize: '7px', margin: 0, textAlign: 'center' }}>Maurício Cheratzki CRM 15302 /PR (41) 3642-6495</p>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '50%', padding: '10px' }}>
                                            <p style={{ fontSize: '10px', margin: '2px', textAlign: 'center' }}>NOME DO MÉDICO DO TRABALHO COORDENADOR DO PCMSO,</p>
                                            <p style={{ fontSize: '10px', margin: '2px', textAlign: 'center' }}>COM CRM E ESTADO EMISSOR</p>
                                            <hr style={{ width: '50%', borderColor: 'black', marginTop: '68px', marginBottom: 0 }} />
                                            <p style={{ fontSize: '7px', margin: 0, textAlign: 'center' }}>Dr. {nomeMedico} CRM {crm} / {uf}</p>
                                        </div>
                                    </div>

                                    {/* DIV PRINCIPAL */}
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', width: '100%', border: '0.5px solid #C0C0C0', borderTop: 'none' }}>
                                        <div style={{ width: '50%' }}>
                                            <h6 style={{ fontSize: '10px', margin: '2px', marginLeft: '5px' }}>APTIDÃO</h6>
                                            <h6 style={{ fontSize: '10px', marginLeft: '5px' }}>
                                                APTO PARA FUNÇÃO [ {determinarAptidao(trabalhoAltura, trabalhoConfinado) === 'APTO' ? 'x' : ''} ]
                                            </h6>
                                        </div>
                                        <div style={{ width: '50%' }}>
                                            <h6 style={{ fontSize: '10px' }}>
                                                INAPTO PARA A FUNÇÃO [ {determinarAptidao(trabalhoAltura, trabalhoConfinado) === 'INAPTO' ? 'x' : ''} ]
                                            </h6>
                                        </div>
                                    </div>

                                    {/* DIV PRINCIPAL */}
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', width: '100%', border: '0.5px solid #C0C0C0', borderTop: 'none' }}>
                                        <div style={{ width: '30%' }}>
                                            <h6 style={{ fontSize: '11px', margin: '2px', marginLeft: '5px' }}>TRABALHOS ESPECIAIS</h6>
                                            <p style={{ fontSize: '10px', margin: '2px', marginLeft: '5px' }}>Trabalho em Altura:</p>
                                            <p style={{ fontSize: '10px', margin: '2px', marginLeft: '5px' }}>Trabalho em Espaço Confinado:</p>
                                        </div>
                                        <div style={{ width: '20%' }}>
                                            <p style={{ fontSize: '10px', margin: '2px' }}>[ {trabalhoAltura == 1 ? 'X' : ''} ] APTO</p>
                                            <p style={{ fontSize: '10px', margin: '2px' }}>[ {trabalhoConfinado == 1 ? 'X' : ''} ] APTO</p>
                                        </div>
                                        <div style={{ width: '20%' }}>
                                            <p style={{ fontSize: '10px', margin: '2px' }}>[ {trabalhoAltura == 2 ? 'X' : ''} ] INAPTO</p>
                                            <p style={{ fontSize: '10px', margin: '2px' }}>[ {trabalhoConfinado == 2 ? 'X' : ''} ] INAPTO</p>
                                        </div>
                                        <div style={{ width: '30%' }}>
                                            <p style={{ fontSize: '10px', margin: '2px' }}>[ {trabalhoAltura == 3 ? 'X' : ''} ] N/A</p>
                                            <p style={{ fontSize: '10px', margin: '2px' }}>[ {trabalhoConfinado == 3 ? 'X' : ''} ] N/A</p>
                                        </div>
                                    </div>

                                    {/* DIV PRINCIPAL */}
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', border: '0.5px solid #C0C0C0', borderTop: 'none' }}>
                                        <h6 style={{ fontSize: '12px', margin: '2px' }}>ASSINATURA DO EMPREGADO</h6>
                                        <h6 style={{ fontSize: '12px', margin: '2px' }}>RECEBI CÓPIA DO ASO NESTA DATA</h6>
                                        {assinadoTrabalhador && (
                                            <>
                                                <p style={{ fontSize: '7px', fontWeight: 'bold', margin: '3px', textAlign: 'center' }}>Assinado digitalmente por: </p>
                                                <p style={{ fontSize: '7px', margin: '1px', textAlign: 'center' }}>{trabalhador?.nome} - {trabalhador?.cpf} </p>
                                            </>
                                        )}
                                        <hr style={{ width: '50%', borderColor: 'black', marginTop: '30px', marginBottom: 0 }}></hr>
                                        {trabalhador && (
                                            <h6 style={{ fontSize: '10px', margin: '2px' }}>{trabalhador.nome}</h6>
                                        )}
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '30px' }}>
                                            <p style={{ fontSize: '10px', margin: '2px' }}>DATA DE EMISSÃO DO ASO:</p>
                                            <p style={{ fontSize: '10px', margin: '2px' }}>{formatarData(new Date().toISOString().split('T')[0])}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {!liberado && (
                            <OverlayTrigger placement="top"
                                overlay={
                                    <Tooltip id={`tooltip-enviar-assinatura`}>
                                        Finalizar Revisão
                                    </Tooltip>
                                }>
                                <Button className='btn-main mt-4' style={{ width: '250px', position: 'fixed', top: '1px', right: '-100px' }} onClick={handleSendPdf} disabled={isSubmitting}>
                                    {isSubmitting ? (
                                        'Enviando...'
                                    ) : (
                                        'Enviar para assinatura'
                                    )}
                                </Button>
                            </OverlayTrigger>
                        )}
                    </Box>
                </Modal>

                <Modal
                    open={showModal}
                    onClose={handleCloseModal}
                    aria-labelledby="confirm-modal-title"
                    aria-describedby="confirm-modal-description"
                >
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: 400,
                            bgcolor: 'background.paper',
                            borderRadius: 2,
                            boxShadow: 24,
                            p: 4,
                        }}
                    >
                        <Typography id="confirm-modal-title" variant="h6" component="h2">
                            Confirmar Liberação
                        </Typography>
                        <Typography id="confirm-modal-description" sx={{ mt: 2 }}>
                            Tem certeza de que deseja liberar o reaproveitamento?
                        </Typography>
                        <Box mt={3} display="flex" justifyContent="flex-end">
                            <MUIButton variant="outlined" onClick={handleCloseModal} sx={{ mr: 2 }}>
                                Cancelar
                            </MUIButton>
                            <MUIButton variant="contained" onClick={handleConfirmSubmit} color="primary">
                                Confirmar
                            </MUIButton>
                        </Box>
                    </Box>
                </Modal>

                <Row className="justify-content-center mb-2">
                    <Col xs="auto">
                        <Button
                            variant="primary"
                            onClick={liberado ? handleOpenPdf : handleOpenModal}
                        >
                            {liberado ? 'Visualizar documento' : 'Liberar Reaproveitamento'}
                        </Button>
                    </Col>
                </Row>
                <AlertMessage
                    show={alert.show}
                    message={alert.message}
                    variant={alert.variant}
                    onClose={() => setAlert({ ...alert, show: false })}
                />
            </Main>
        </div>

    );
}